import React, { ReactElement, ReactNode, createContext, useContext, useMemo } from 'react';

const SocketContext = createContext(null);

export const useSocket = () => {
   const context = useContext(SocketContext);
   if (!context) {
      throw new Error('useSocket must be used within a SocketProvider');
   }
   return context.webSocket;
};

export const SocketProvider = (props) => {
   const apiKey = 'testing_api_1';
   const url = `wss://aiworkshiftai.intellexio.com/predict?apiKey=${apiKey}`;
   const { children } = props;
   const ws = new WebSocket(url);
   const webSocket = useMemo(() => ws, []);

   return <SocketContext.Provider value={{ webSocket: webSocket }}>{children}</SocketContext.Provider>;
};
